import { render, staticRenderFns } from "./Storybook.vue?vue&type=template&id=30f80980"
import script from "./Storybook.vue?vue&type=script&lang=js"
export * from "./Storybook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports